import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_NO.json';
import exercises from './YOGA_EXERCISES_NO.json';
import recipes from './YOGA_RECIPES_NO.json';

export const YOGA_DATA_NO: ServiceData = {
  articles,
  exercises,
  recipes,
};
